const transporters = require('../../transporters.json');

module.exports = function getTransporter(code) {
    return transporters.find(transporter => transporter.code === code);
}